import PropTypes from "prop-types";
import React, {PureComponent} from "react";
import {connect} from "react-redux";

import {ActionCreator} from "../reducers/application/application";
import {Archive} from "./archive";
import {Header} from "./header";
import {MapMain} from "./map-main";
import {Sidebar} from "./sidebar";


class MainPageComponent extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.onPageLoad();
  }

  render() {
    return (
      <main className="main">
        <div className="main__sidebar">
          <Sidebar />
        </div>

        <div className="main__page-content">
          <section className="page-content">
            <h2 className="visually-hidden">Блок карты</h2>

            <Header
              title="Интерактивная карта районов добычи (вылова) водных биологических ресурсов (демо версия)"
            />
            <MapMain />
            <Archive />
          </section>
        </div>
      </main>
    );
  }
}


MainPageComponent.propTypes = {
  onPageLoad: PropTypes.func.isRequired,
};


const mapDispatchToProps = (dispatch) => ({
  onPageLoad() {
    dispatch(ActionCreator.setActivePoolId(null));
    dispatch(ActionCreator.setActiveAreaId(null));
  },
});

const MainPage = connect(null, mapDispatchToProps)(MainPageComponent);


export {
  MainPageComponent,
  MainPage,
};
